import { Button, Checkbox, DatePicker, Divider, Form, Input, Radio, Select } from 'antd'
import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../GlobalContext'
import { post } from '../../Common/api'
import { notificationSuccess } from '../../Common/Common'
import { useForm } from 'antd/es/form/Form'
import { t } from 'i18next'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function FeedbackForm ({ slot, setSlot, setLoading, setModalVisible, style }) {
  const [form] = useForm()
  const [choicesValues, setChoicesValues] = useState({})
  const [otherOnChange, setOtherOnChange] = useState({})
  const { data } = useContext(GlobalContext)
  const [initialValues, setInitialValues] = useState()
  const feedbackAlreadyCreated = slot.feedback.find((e) => e.question.order === 0).answers.length > 0
  const screens = useBreakpoint()

  const labelCol = screens.xl ? { span: 8 } : { span: 6 }

  const fieldValue = (field) => {
    let value
    if (field.question.order === 0) {
      value = slot.box.name
    } else if (field.question.order === 4) {
      value = dayjs(slot.begin_date)
    } else if (field.question.order === 5) {
      value = dayjs(slot.begin_date).format('dddd')
      value = value.charAt(0).toUpperCase() + value.slice(1)
    } else if (field.question.order === 6) {
      value = field.question.choices.find((choice) => parseInt(choice.split('-')[0]) === dayjs(slot.begin_date).hour())
    } else if (field.question.order === 15) {
      value = `${slot.booked_slots.count} fois`
    }
    return value
  }

  const fieldInput = (field) => {
    if (field.question.field_type === 'single_choice') {
      return singleChoiceField(field)
    } else if (field.question.field_type === 'multiple_choice') {
      return multipleChoiceField(field)
    } else if (field.question.field_type === 'dropdown') {
      return dropdownField(field)
    } else if (field.question.field_type === 'date') {
      return dateField()
    } else if (field.question.field_type === 'string') {
      return stringField()
    }
  }

  const addFieldToArray = (fields, field) => {
    fields.push(
      <Form.Item name={field.question.order} label={field.question.value} labelCol={labelCol} wrapperCol={{ span: 12 }} >
        {fieldInput(field)}
      </Form.Item>
    )
    fields.push(<Form.Item name={`${field.question.order}_id`} hidden><Input /></Form.Item>)
    if (field.question.field_type === 'single_choice' || field.question.field_type === 'multiple_choice') {
      const hidden = field.question.field_type === 'single_choice' ? choicesValues[field.question.order] !== 'Autre' : choicesValues[field.question.order] === undefined || !choicesValues[field.question.order].includes('Autre')
      fields.push(<Form.Item name={`${field.question.order}_other`} wrapperCol={{ span: 12, offset: 8 }} hidden={hidden}><Input /></Form.Item>)
    }
    fields.push(<Divider style={{ minWidth: '50%', width: '50%', margin: '24px 25%' }} />)
  }

  const displayFields = (slot) => {
    const fields = []
    slot.feedback.forEach((field) => {
      addFieldToArray(fields, field)
    })
    return fields
  }

  const singleChoiceField = (field) => {
    const style = { display: 'flex', flexDirection: 'column', gap: 8 }
    return (
      <Radio.Group options={field.question.choices} style={style} onChange={(event) => otherOnChange.single(event, choicesValues)} name={`${field.question.order}`} />
    )
  }

  const multipleChoiceField = (field) => {
    const style = { display: 'flex', flexDirection: 'column', gap: 8 }
    return (
      <Checkbox.Group options={field.question.choices} style={style} onChange={(values) => otherOnChange[field.question.order](values, choicesValues)} />
    )
  }

  const dropdownField = (field) => (
    <Select options={field.question.choices.map((o) => ({ label: o, value: o }))} />
  )

  const dateField = () => (
    <DatePicker format={'DD/MM/YYYY'} />
  )

  const stringField = () => (
    <Input />
  )

  const singleAnswerFormatting = (params, values, index, feedback) => {
    const value = values[index] === 'Autre' ? values[`${index}_other`] : values[index]
    if (feedback.answers.length > 0) {
      updateExistingAnswer(params, feedback.answers[0], value)
    } else if (value !== undefined) {
      addNewAnswer(params, values[`${index}_id`], value)
    }
  }

  const multipleAnswerFormatting = (params, values, index, feedback) => {
    if (values[index]) {
      feedback.answers.forEach((answer) => {
        if (values[index].includes(answer.value)) {
          keepExistingAnswer(params, answer)
        } else {
          destroyExistingAnswer(params, answer)
        }
      })
      values[index].forEach((value) => {
        if (!params.feedback_answers_attributes.map((e) => e.value).includes(value)) {
          value = value === 'Autre' ? values[`${index}_other`] : value
          addNewAnswer(params, values[`${index}_id`], value)
        }
      })
    } else {
      feedback.answers.forEach((answer) => {
        destroyExistingAnswer(params, answer)
      })
    }
  }

  const keepExistingAnswer = (params, answer) => {
    params.feedback_answers_attributes.push(answer)
  }

  const updateExistingAnswer = (params, answer, value) => {
    params.feedback_answers_attributes.push({ ...answer, value })
  }

  const addNewAnswer = (params, questionId, value) => {
    params.feedback_answers_attributes.push({
      feedback_question_id: questionId,
      user_id: data.user.id,
      value
    })
  }

  const destroyExistingAnswer = (params, answer) => {
    params.feedback_answers_attributes.push({ ...answer, _destroy: 1 })
  }

  const onFinish = (values) => {
    const params = { feedback_answers_attributes: [] }
    for (let index = 0; index < slot.feedback.length; index++) {
      const feedback = slot.feedback.find((e) => e.question.order === index)
      if (feedback.question.field_type !== 'multiple_choice') {
        singleAnswerFormatting(params, values, index, feedback)
      } else {
        multipleAnswerFormatting(params, values, index, feedback)
      }
    }
    saveFeedback(params)
  }

  const saveFeedback = (params) => {
    setLoading(true)
    post(`admin/slots/${slot.id}/update_feedback`, params, (response) => {
      setLoading(false)
      setModalVisible(false)
      setSlot({ ...slot, feedback: response.feedback })
      notificationSuccess('update')
    })
  }

  const setSingleDefaultValues = (defaultValues, choices) => {
    slot.feedback.filter((f) => f.question.field_type !== 'multiple_choice').forEach((f) => {
      if (feedbackAlreadyCreated && f.answers.length > 0) {
        setSingleDefaultValuesWithCreatedAnswers(f, defaultValues, choices)
      } else if (!feedbackAlreadyCreated) {
        defaultValues[f.question.order] = fieldValue(f)
      }
      defaultValues[`${f.question.order}_id`] = f.question.id
    })
  }

  const setSingleDefaultValuesWithCreatedAnswers = (f, defaultValues, choices) => {
    if (f.question.field_type === 'date') {
      defaultValues[f.question.order] = dayjs(f.answers[0].value)
    } else if (f.question.field_type === 'single_choice' && !f.question.choices.includes(f.answers[0].value)) {
      defaultValues[f.question.order] = 'Autre'
      defaultValues[`${f.question.order}_other`] = f.answers[0].value
      choices[f.question.order] = 'Autre'
    } else {
      defaultValues[f.question.order] = f.answers[0].value
    }
  }

  const setMultipleDefaultValues = (defaultValues, choices, methods) => {
    slot.feedback.filter((f) => f.question.field_type === 'multiple_choice').forEach((f) => {
      if (feedbackAlreadyCreated) {
        setMultipleDefaultValuesWithCreatedAnswers(f, defaultValues, choices)
      }
      defaultValues[`${f.question.order}_id`] = f.question.id
      methods[f.question.order] = (values, choices) => {
        const currentValues = { ...choices }
        currentValues[f.question.order] = values
        setChoicesValues(currentValues)
      }
    })
  }

  const setMultipleDefaultValuesWithCreatedAnswers = (f, defaultValues, choices) => {
    defaultValues[f.question.order] = []
    f.answers.forEach((answer) => {
      if (!f.question.choices.includes(answer.value)) {
        defaultValues[f.question.order].push('Autre')
        defaultValues[`${f.question.order}_other`] = answer.value
        choices[f.question.order] = 'Autre'
      } else {
        defaultValues[f.question.order].push(answer.value)
      }
    })
  }

  useEffect(() => {
    const defaultValues = {}
    const choices = {}
    const methods = {}
    setSingleDefaultValues(defaultValues, choices)
    setMultipleDefaultValues(defaultValues, choices, methods)
    methods.single = (event, choices) => {
      const currentValues = { ...choices }
      currentValues[event.target.name] = event.target.value
      setChoicesValues(currentValues)
    }
    setInitialValues(defaultValues)
    setChoicesValues(choices)
    setOtherOnChange(methods)
  }, [slot])

  return (
    <>
      { initialValues &&
        <Form form={form} onFinish={onFinish} initialValues={initialValues} style={style} labelWrap>
          {displayFields(slot)}
          <Button type="primary" style={{ float: 'right', marginRight: '4em' }}
            htmlType="submit" onClick={form.submit} disabled={slot.is_cancel}>
            {t('Admin.btn.save')}
          </Button>
        </Form>
      }
    </>
  )
}
